import React, { useState } from "react";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { Validation } from "../../../domain/validation/Validation";
import { Card, Stack } from "@mui/material";
import {
  STRINGS_EMAIL,
  STRINGS_EMAIL_NOT_VALID,
  STRINGS_EMAIL_REQUIRED,
  STRINGS_LOGIN,
  STRINGS_PASSWORD,
  STRINGS_PASSWORD_REQUIRED,
} from "../../../data/strings/Strings";
import {
  COLOR_BLACK,
  COLOR_LESS_BLACK,
  COLOR_LIGHT_GRAY,
  COLOR_MAIN,
  COLOR_WHITE,
} from "../../../data/colors/Colors";
import useWindowDimensions from "../../../core/utils/UseWindowDimensions";
import AutoHeight from "../../component/AutoHeightView";
import { EmailRounded, LockRounded } from "@mui/icons-material";
import { CustomTextView } from "../../component/CustomTextView";
import { CustomTextField } from "../../component/CustomTextField";
import { MAIN_FONT_FAMILY } from "../../../data/constant/Constants";
import { CustomButtonView } from "../../component/CustomButtonView";

interface LoginFormProps {
  onSubmit: (email: string, password: string) => void;
}

function LoginForm({ onSubmit }: LoginFormProps) {
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const handleEmailChange = (email: string) => {
    setEmail(email);
  };

  const handlePasswordChange = (password: string) => {
    setPassword(password);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const errors = validateInputs();
    setErrors(errors);

    if (Object.keys(errors).length === 0) onSubmit(email, password);
  };

  const validateInputs = () => {
    const errors: { [key: string]: string } = {};
    const emailValid = Validation.validateEmail(email);
    if (emailValid !== true) {
      errors.email = STRINGS_EMAIL_NOT_VALID;
    }
    if (email.length === 0) {
      errors.email = STRINGS_EMAIL_REQUIRED;
    }
    if (password.length === 0) {
      errors.password = STRINGS_PASSWORD_REQUIRED;
    }
    return errors;
  };

  const { width } = useWindowDimensions();

  return (
    <Box component="form" onSubmit={handleSubmit} noValidate>
      <Card
        elevation={0}
        sx={{
          flex: 1,
          padding: "6%",
          borderRadius: 6,
          minWidth:
            width < 700
              ? "90vw"
              : width < 1200
              ? "80vw"
              : width < 1400
              ? "40vw"
              : "25vw",
          width: width < 700 ? "100%" : "75%",
          backdropFilter: "blur(10px)",
          backgroundColor: "rgba(65, 65, 65, 0.2)",
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Stack spacing={8} flex={1}>
          <Stack spacing={1}>
            <CustomTextView
              text={STRINGS_LOGIN}
              variant="h4"
              textColor={COLOR_WHITE}
              fontWeight="700"
            />
            <CustomTextView
              text={"SoomTech"}
              variant="body1"
              textColor={COLOR_LIGHT_GRAY}
            />
          </Stack>

          <Stack spacing={2}>
            <AutoHeight>
              <CustomTextField
                type="email"
                placeholder={STRINGS_EMAIL}
                isFullWidth
                onTextChange={handleEmailChange}
                error={!!errors.email}
                helperText={errors.email}
                startIcon={<EmailRounded sx={{ color: COLOR_WHITE }} />}
                textColor={COLOR_WHITE}
                onHoverBorderColor={COLOR_LIGHT_GRAY}
                onFocusBorderColor={COLOR_LIGHT_GRAY}
                borderColor={COLOR_WHITE}
                backgroundColor={"transparent"}
              />
            </AutoHeight>
            <AutoHeight>
              <CustomTextField
                type="password"
                placeholder={STRINGS_PASSWORD}
                isFullWidth
                onTextChange={handlePasswordChange}
                error={!!errors.password}
                helperText={errors.password}
                startIcon={<LockRounded sx={{ color: COLOR_WHITE }} />}
                textColor={COLOR_WHITE}
                onHoverBorderColor={COLOR_LIGHT_GRAY}
                onFocusBorderColor={COLOR_LIGHT_GRAY}
                borderColor={COLOR_WHITE}
                backgroundColor={"transparent"}
              />
            </AutoHeight>
            <CustomButtonView
              text={STRINGS_LOGIN}
              type="submit"
              fontSize="h6"
              props={{ pt: 1, pb: 1 }}
            />
          </Stack>
        </Stack>
      </Card>
    </Box>
  );
}

export default LoginForm;
